module.exports = __webpack_public_path__ + "static/media/BLUE.0da8d90f.png";